// Auth route — "We sent you a link" (US-003).

import { createRoute } from '@tanstack/react-router';

import { VerifyPendingPage } from '@/features/auth/VerifyPendingPage';

import { Route as RootRoute } from '../__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/auth/verify-pending',
  validateSearch: (search): { email?: string } => ({
    email: typeof search.email === 'string' ? search.email : undefined,
  }),
  component: VerifyPendingPage,
});
